<template>
  <div class="mb-10 gap-y-3 flex flex-column">
    <div class="flex align-center bg-gray-200 py-3 rounded-xl">
      <span class="flex-1 text-center text-lg font-extrabold">Catégorie</span>
      <span v-if="hasExcluded" class="flex-1 text-center text-lg font-extrabold">{{ data.statistics.excluded.short }}</span>
      <span class="flex-1 text-center text-lg font-extrabold">{{ data.statistics.included.short }}</span>
    </div>
    <program-digest-groups-row
      v-for="(item, index) in requiredGroups"
      :key="index"
      :row="data.statistics.included[item] as SupportProgramGroup"
      :has-excluded="hasExcluded"
      :slug="item"
      :settings="settings"
      @update:enabled="(slug: string, enabled: boolean) => emits('update:group-settings', slug, enabled)"
    />
    <template v-if="optionalGroups.length">
      <p class="font-semibold mt-4">
        Activez ces ciblages supplémentaires pour détecter plus de patients
      </p>
      <program-digest-groups-row
        v-for="(item, index) in optionalGroups"
        :key="`optional-${index}`"
        :row="data.statistics.included[item] as SupportProgramGroup"
        :has-excluded="hasExcluded"
        :slug="item"
        :settings="settings"
        @update:enabled="(slug: string, enabled: boolean) => emits('update:group-settings', slug, enabled)"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import {computed} from "vue";
import ProgramDigestGroupsRow from '@/program/components/program-statistics/ProgramDigestGroupsRow.vue';
import {SupportProgram, SupportProgramGroup, SupportProgramSettings} from "@/program/interfaces/Program";
import SupportProgramStatisticsService from "@/program/services/SupportProgramStatisticsService";

const emits = defineEmits<{
    (e: 'update:group-settings', slug: string, enabled: boolean): void
}>();

const {data, hasExcluded, settings} = defineProps<{
    data: SupportProgram;
    hasExcluded: boolean;
    settings: SupportProgramSettings;
}>();

/**
 * Compute the included groups, filtering out unwanted keys.
 */
const filteredGroups = computed(() => {
    return SupportProgramStatisticsService.getSupportProgramGroupKeys(data.statistics.included);
});

/**
 * The non-optional groups, always targeted.
 */
const requiredGroups = computed(() => {
    return filteredGroups.value.filter(
        item => !(data.statistics.included[item] as SupportProgramGroup)?.optional
    );
});

/**
 * The optional groups, that can be enabled to target more patients.
 */
const optionalGroups = computed(() => {
    return filteredGroups.value.filter(
        item => (data.statistics.included[item] as SupportProgramGroup)?.optional
    );
});
</script>
